import type * as api from '@gitbook/api-client';

import type { ContentKitLocalState } from './types';

/**
 * Resolve a potential dynamic binding as a plain value.
 */
export function resolveDynamicBinding<T extends {}>(
    localState: ContentKitLocalState,
    value: api.ContentKitDynamicBinding | T
): T {
    if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'undefined'
    ) {
        // Primitives
        return value;
    }

    if (Array.isArray(value)) {
        // @ts-ignore
        return value.map((v) => resolveDynamicBinding(localState, v));
    }

    if ('$state' in value && typeof value.$state === 'string') {
        return localState[value.$state];
    }

    // Plain object
    const result = {};
    Object.entries(value).forEach(([key, keyValue]) => {
        result[key] = resolveDynamicBinding(localState, keyValue);
    });

    // @ts-ignore
    return result;
}
